import type { FC } from 'react'
import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import type { PublicationDataDtoV1 } from '@/api/kubik/infoportal'
import { Image } from '@/components/ui'
import { useFormatDate } from '@/utils/hooks/format/useFormatDate'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { getJournalPublicationUrl } from '@/utils/infoportal/helpers'
import { JournalGtmClickEventPayload } from '../../../Journal/gtmConstants'
import { openArticleClicked } from '../../../Journal/gtmHelpers'
import './styles.scss'

const JournalNewsItem: FC<{
  newsItem: PublicationDataDtoV1
  previousNewsItemPublicationDate?: string
  isFirst: boolean
}> = ({ newsItem, isFirst, previousNewsItemPublicationDate }) => {
  const { isDesktop } = useDeviceType()
  const { formatDate } = useFormatDate()
  const { title, subtitle, slug, coverImage, showCover, publicationDate } = newsItem
  const newsDate = publicationDate ? formatDate(publicationDate, 'dd MMMM yyyy') : undefined

  const shouldShowDate =
    newsDate && (!previousNewsItemPublicationDate || newsDate !== formatDate(previousNewsItemPublicationDate, 'dd MMMM yyyy'))

  return (
    <>
      {shouldShowDate && (
        <h4 className="journal-news-announce-date">
          <time dateTime={newsDate}>{newsDate}</time>
        </h4>
      )}

      <article key={slug} className="journal-news-announce" onClick={openArticleClicked(JournalGtmClickEventPayload.listArticles)}>
        <CommonLink url={getJournalPublicationUrl(slug)} className="journal-news-announce-link">
          <div className="row row_column">
            <h5 className="journal-news-announce__title">{title}</h5>

            {subtitle && <p className={`text_${isDesktop ? 'L' : 'M'} space-holder-top16 journal-news-announce__text `}>{subtitle}</p>}
          </div>

          {isFirst && showCover && <Image src={coverImage?.squareCover} isBackground className="journal-news-announce__image" />}
        </CommonLink>
      </article>
    </>
  )
}

export default JournalNewsItem
